import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-3 flex items-center justify-center" }
const _hoisted_2 = ["innerHTML"]

import { IonCol, IonContent, IonGrid, IonPage, IonRow } from "@ionic/vue";
import { useConnectionStore } from "@/modules/connection/store/connection";
import { useDirectusStore } from "@/modules/directus/store/directus";
import { isPlatform, type Platforms, useIonRouter } from "@ionic/vue";
import { onMounted, ref } from "vue";
import { App } from "@capacitor/app";
import { readItems } from "@directus/sdk";
import { compareVersions } from "compare-versions";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReleaseView',
  setup(__props) {

const loading = ref(true);
const error = ref(false);
const content = ref("");
const ionRouter = useIonRouter();
const directus = useDirectusStore();

onMounted(async () => {
  const platforms: Platforms[] = ["ios", "android"];
  const platform = platforms.find((availablePlatform) =>
    isPlatform(availablePlatform)
  );
  if (platform) {
    try {
      const appVersion = (await App.getInfo()).version;
      const release = (await directus.main.request(readItems("releases"))).find(
        (release) => release.platform === platform
      );
      if (
        release &&
        release.version &&
        compareVersions(release.version, appVersion) === 1
      ) {
        content.value = release.description;
      }
    } catch (_error) {
      if (useConnectionStore().connectionStatus?.connected) {
        error.value = true;
        return;
      }
    }
  }
  loading.value = false;

  ionRouter.push({
    name: "cities",
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(IonGrid), null, {
              default: _withCtx(() => [
                _createVNode(_unref(IonRow), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonCol), null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", { innerHTML: content.value }, null, 8, _hoisted_2)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})